module.exports = __webpack_public_path__ + "static/media/google-icon.3a59eb95.svg";